module.exports = __webpack_public_path__ + "static/media/spinner.33c112d5.svg";